import { Flex, Typography, List, IconClose } from '@banhala/ui-kit';
import { useEffect, useRef } from 'react';
import type { ListRef } from '@banhala/ui-kit';
import { SearchType } from 'shared/src/api/enums';
import { useLogSearchKeyword } from '../../hook/useLogSearchKeyword';
import { Accessibility } from '../../../../utils/accessibility';
import { useLogClickRemoveKeyword } from '../../hook/useLogClickRemoveKeyword';

type RecentKeywordItem = {
  keyword: string;
  is_delete: boolean;
};

type Props = {
  keywords: RecentKeywordItem[];
  isEditMode: boolean;
  onDelete: (keyword: string) => void;
  onPress: (keyword: string) => void;
  resetScrollTrigger?: number;
};

export const RecentKeywordList = ({
  keywords,
  isEditMode,
  onDelete,
  onPress,
  resetScrollTrigger,
}: Props) => {
  const listRef = useRef<ListRef<RecentKeywordItem> | null>(null);
  const logSearchKeyword = useLogSearchKeyword();
  const logRemoveKeyword = useLogClickRemoveKeyword();

  // viewDidAppear 시 스크롤 시작 위치 초기화
  useEffect(() => {
    if (resetScrollTrigger && resetScrollTrigger > 0) {
      listRef.current?.scrollToOffset({ offset: 0, animated: false });
    }
  }, [resetScrollTrigger]);

  return (
    <List
      ref={listRef}
      horizontal
      data={keywords}
      keyExtractor={(item, index) => `${item.keyword}-${index}`}
      showsHorizontalScrollIndicator={false}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={{
        paddingHorizontal: 16,
        marginTop: 4,
        marginBottom: 12,
      }}
      renderItem={({ item, index }) => (
        <Flex.Row
          testID={Accessibility.Search.recentKeywordListItem(
            item.keyword,
            index,
          )}
          alignItems="center"
          height={32}
          padding={{ horizontal: 12 }}
          backgroundColor="content_always_white"
          borderRadius={16}
          borderWidth={1}
          borderColor={'gray30'}
          margin={{ right: 8 }}
          onPress={() => {
            if (isEditMode) {
              logRemoveKeyword({
                searchType: SearchType.RECENT,
                keyword: item.keyword,
              });
              onDelete(item.keyword);
            } else {
              logSearchKeyword({
                searchType: SearchType.RECENT,
                keyword: item.keyword,
                clickIndex: index,
              });
              onPress(item.keyword);
            }
          }}
          gap={2}
        >
          {/* 큰 글꼴 설정 기기에서 칩(height 32) 안 텍스트가 개행되는 것 방지 (ENABLE-1109) */}
          <Typography
            type="subtitle3"
            color={'content_secondary'}
            numberOfLines={1}
          >
            {item.keyword}
          </Typography>
          {isEditMode && <IconClose size={16} fill="#777777" />}
        </Flex.Row>
      )}
    />
  );
};
